import { useTranslation } from 'react-i18next';
import { useGetFlexibleBenefitsPayrollSummary } from '@/common/integrations/menhir/employee/flexible-benefits/flexible-benefits.hooks';
import { FlexibleBenefitsBenefitActivity } from '@/web/containers/Dashboard/ESWalletDashboard/containers/Benefits/containers/ESWalletBenefitDetail/containers/ESWalletBenefitDetailDefault/components/FlexibleBenefitsBenefitActivity/FlexibleBenefitsBenefitActivity';
import { useActivityFilters } from '@/web/containers/Dashboard/ESWalletDashboard/containers/Benefits/containers/ESWalletBenefitDetail/containers/ESWalletBenefitDetailDefault/components/FlexibleBenefitsBenefitActivity/useActivityFilters';
import { Card, Flex, Label, Text } from '@coverflex-tech/hypernova';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';
import { css } from './FlexibleBenefitsActivity.css';

export const FlexibleBenefitsActivity = () => {
  const { t } = useTranslation();
  const { periodId } = useActivityFilters();
  const { summary, isInitialLoading } = useGetFlexibleBenefitsPayrollSummary(
    {
      periodId,
    },
    { enabled: !!periodId }
  );
  return (
    <FlexibleBenefitsBenefitActivity isLoading={isInitialLoading}>
      {summary && (
        <Card className={css.payrollCard} plain>
          <Flex flexDirection="column" gap="md">
            <Text>
              {t('dashboard.home.es.wallet.benefits_widget.payroll.title')}
            </Text>
            <Label size="xl" bold>
              {MoneyUtils.moneyToString(summary.total)}
            </Label>
          </Flex>
        </Card>
      )}
    </FlexibleBenefitsBenefitActivity>
  );
};
